import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { ErrorManagementService } from '../services/error-management.service';

@Injectable()
export class ApiErrorInterceptor implements HttpInterceptor {
    private readonly IGNORE_URLS = ['assets/i18n', 'status/health'];

    constructor(private errorManagementService: ErrorManagementService) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (this.IGNORE_URLS.some((ignored) => request.url.includes(ignored))) {
            return next.handle(request);
        }
        return next.handle(request).pipe(
            catchError((response) => {
                this.errorManagementService.handleError(request, response);
                return throwError(() => response);
            })
        );
    }
}
